import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Button, Stack, Typography, useTheme } from '@mui/material';

export type SourceButtonProps = {
  title: string;
  subtitle: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const SourceButton = ({ onClick, title, subtitle, disabled }: SourceButtonProps) => {
  const theme = useTheme();
  return (
    <Button
      component="div"
      startIcon={
        <DescriptionOutlinedIcon
          fontSize="large"
          sx={{
            marginX: theme.spacing(),
          }}
        />
      }
      disabled={disabled}
      fullWidth
      disableRipple
      variant="outlined"
      color="inherit"
      onClick={onClick}
      sx={{
        justifyContent: 'left',
        textTransform: 'none',
        padding: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderColor: theme.palette.divider,
      }}
    >
      <Stack>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="caption">{subtitle}</Typography>
      </Stack>
    </Button>
  );
};
